import { render, staticRenderFns } from "./CollapsibleHeading.vue?vue&type=template&id=9b5bed28"
import script from "./CollapsibleHeading.vue?vue&type=script&lang=ts"
export * from "./CollapsibleHeading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports